import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import FloatingSidebar from './components/FloatingSidebar';
import CanonicalURL from './components/CanonicalURL';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Disclaimer from './pages/Disclaimer';

// Service Pages
import OneTonTruck from './pages/services/OneTonTruck';
import ThreeTonTruck from './pages/services/ThreeTonTruck';
import FiveTonTruck from './pages/services/FiveTonTruck';
import SevenTonTruck from './pages/services/SevenTonTruck';
import TenTonTruck from './pages/services/TenTonTruck';

// Blog Pages
import BlogHome from './pages/blog/BlogHome';
import PickupTruckRentalGuide from './pages/blog/PickupTruckRentalGuide';
import BestMoversPackersDubai from './pages/blog/BestMoversPackersDubai';

function App() {
  return (
    <Router>
      <div className="App">
        <CanonicalURL />
        <ScrollToTop />
        <Header />
        <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/1-ton-truck" element={<OneTonTruck />} />
              <Route path="/3-ton-truck" element={<ThreeTonTruck />} />
              <Route path="/5-ton-truck" element={<FiveTonTruck />} />
              <Route path="/7-ton-truck" element={<SevenTonTruck />} />
              <Route path="/10-ton-truck" element={<TenTonTruck />} />
              <Route path="/blog" element={<BlogHome />} />
              <Route path="/pickup-truck-rental-guide-dubai" element={<PickupTruckRentalGuide />} />
              <Route path="/best-movers-packers-dubai-2025" element={<BestMoversPackersDubai />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="*" element={<Home />} />
            </Routes>
        </main>
        <Footer />
        <FloatingSidebar />
      </div>
    </Router>
  );
}

export default App;